import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../../base';
import { DataType } from '../../../data';
import { Rule } from '../../base/mutation-rules';
import { SubChart } from './sub-chart';
import type { MaybeError } from '../../base/base-mutation';
import type { IValidAddSubChartMutationData, IValidRemoveSubChartMutationData } from '../../base';
import type { PresentationDataModel } from '../../../model/presentation-data-model';

export class AddSubChartMutation extends BaseMutation<PresentationDataModel, IValidAddSubChartMutationData> {
    public readonly type: MutationType = MutationType.AddSubChart;

    public apply(presentation: PresentationDataModel) {
        const { shapeId, index, subChartType } = this.data;

        const chart = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameChart);
        assert(chart, 'chart should exist');

        const subChart = new SubChart().toSdkSubChart(subChartType, {});

        chart.store.addSubChart(subChart, index);
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId, index } = this.data;

        return Rule.every(
            Rule.shape.should.existInPage(presentation, this.data.shapeId, this.data.pageId),
            Rule.chart.is.inSideSubChartRange(presentation, pageId, shapeId, index),
        );
    }

    public invert(presentation: PresentationDataModel): [IValidRemoveSubChartMutationData] {
        const { pageId, shapeId, index } = this.data;

        const chart = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameChart);
        assert(chart, 'chart should exist');

        return [
            {
                type: MutationType.RemoveSubChart,
                pageId,
                shapeId,
                index,
            },
        ];
    }
}
